import _toConsumableArray from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import Subject from './compontents/subject.vue';
import Records from './compontents/view-records.vue';
import Services from './compontents/services.vue';
import SelfStudy from './compontents/self-study.vue';
import UnbindModel from './models/unbind-model.vue';
import Filing from '@/components/filing.vue';
import { getUserInfoDetail } from '@/api/login';
import { getHistory as _getHistory, getServices as _getServices, getBoxes as _getBoxes } from '@/api/home';
import { getSubjectList } from '@/api/modules/study.js';
import OutlineCache from '@/utils/OutlineCache.js';
import QuickHelp from './compontents/quick-help.vue';
import ExperienceDrawer from './compontents/experience-mode/index.vue';
var DEFAULT_SERVICES = [{
  type: 1,
  title: '薄弱知识点专项练习',
  className: 'item__content--weak'
}, {
  type: 3,
  title: '已掌握知识点难度提升练习',
  className: 'item__content--difficulty'
}, {
  type: 2,
  title: '错题相似练习',
  className: 'item__content--similar'
}, {
  type: 6,
  title: '错题本',
  className: 'item__content--error'
}];
var cache;
export default {
  name: 'Home',
  components: {
    Subject: Subject,
    Records: Records,
    Services: Services,
    SelfStudy: SelfStudy,
    UnbindModel: UnbindModel,
    QuickHelp: QuickHelp,
    Filing: Filing,
    ExperienceDrawer: ExperienceDrawer
  },
  data: function data() {
    var user = JSON.parse(localStorage.getItem('userInfo'));
    return {
      user: user,
      // 绑定模态框
      unbindVisible: false,
      edu: user.edu || 3,
      bindHomeSubjectFullDigShow: false,
      subjectList: [],
      // 当前学科
      selectedSubject: {},
      // 历史记录参数
      showMoreBtn: true,
      isRecordLoading: false,
      recordParams: {
        pageSize: 20,
        offset: 0
      },
      // 历史记录列表
      recordList: [],
      // 服务列表
      serviceList: DEFAULT_SERVICES,
      // 自学宝
      studyList: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    subjectCode: 'subjectGetters',
    studyBindSuccess: 'studyBindSuccess',
    unBindSubject: 'unBindSubject',
    closeCodeDialog: 'closeCodeDialog',
    userMode: 'userMode'
  })), {}, {
    isExperienceMode: function isExperienceMode() {
      return this.userMode === 'experience';
    },
    isUnBind: function isUnBind() {
      return this.unBindSubject && !this.isExperienceMode;
    }
  }),
  watch: {
    'subjectCode': function subjectCode(val) {
      if (this.subjectList.length === 0) return;
      var subject = this.subjectList.find(function (item) {
        return item.code === val;
      });
      this.subjectChange(subject);
    },
    'studyBindSuccess': function studyBindSuccess() {
      this.init();
    },
    'closeCodeDialog': function closeCodeDialog(val) {
      val && this.init();
    },
    'userMode': function userMode() {
      this.init();
    }
  },
  created: function created() {
    cache = OutlineCache.getInstance();
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var length;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 初始化参数
                length = _this.recordList.length;
                _this.recordParams = {
                  offset: 0,
                  // 长度小于20时，防止showBtn在第一次获取时隐藏，关闭弹窗刷新又重新显示，将pageSize设置为最小20
                  pageSize: length < 20 ? 20 : length
                };
                _context.next = 4;
                return _this.getSubjects();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    toggleUnbind: function toggleUnbind() {
      this.unbindVisible = !this.unbindVisible;
    },
    // 修改subjectCode
    setSubject: function setSubject(subject) {
      this.recordParams = {
        offset: 0,
        pageSize: 20
      }; // 切换学科需要将showMoreBtn设为展示

      this.showMoreBtn = this.subjectCode === subject.code ? this.showMoreBtn : true;
      this.$store.dispatch('setSubject', subject.code);
    },
    subjectChange: function subjectChange(subject) {
      if (!subject) {
        return;
      }

      this.selectedSubject = subject;
      this.getUserName();
      this.getHistory();
      this.getServices();
      this.getBoxes();
      this.$store.dispatch('setSubject', subject.code);
      cache.switchSubject(this.edu, subject.code, true);
    },
    getUserName: function getUserName() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$getUserInfoDet, status, data, name, avaterUrl;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  uid: _this2.user.uid
                };
                _context2.next = 3;
                return getUserInfoDetail(params);

              case 3:
                _yield$getUserInfoDet = _context2.sent;
                status = _yield$getUserInfoDet.status;
                data = _yield$getUserInfoDet.data;

                if (status === 1 && data) {
                  name = data.name, avaterUrl = data.avaterUrl;

                  _this2.$store.dispatch('setUsername', name);

                  _this2.$store.dispatch('setUserAvatar', avaterUrl);
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getSubjects: function getSubjects() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$getSubjectList, status, data, subject;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getSubjectList({
                  edu: _this3.edu,
                  needAll: false
                });

              case 2:
                _yield$getSubjectList = _context3.sent;
                status = _yield$getSubjectList.status;
                data = _yield$getSubjectList.data;

                if (status === 1) {
                  // 未绑定
                  if (!data || data.length === 0) {
                    _this3.subjectList = [];
                    _this3.selectedSubject = {}; // this.unbindVisible = true

                    _this3.$store.dispatch('setUnbindSubject', true);

                    _this3.getUserName();

                    _this3.userMode === 'normal' && _this3.$router.push({
                      path: '/active'
                    });
                  } else {
                    _this3.subjectList = data;
                    subject = _this3.subjectCode ? data.find(function (item) {
                      return item.code === _this3.subjectCode;
                    }) || data[0] : data[0];

                    _this3.subjectChange(subject);

                    _this3.unbindVisible = false;

                    _this3.$store.dispatch('setUnbindSubject', false);
                  }
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getMoreRecord: function getMoreRecord() {
      this.recordParams = {
        pageSize: 20,
        offset: this.recordList.length
      };
      this.isRecordLoading = true;
      this.getHistory();
    },
    getHistory: function getHistory() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var subjectId, _this4$recordParams, pageSize, offset, _yield$_getHistory, status, data, HISTORY_CLASSNAME_MAP, SUB_NAME_MAP, SUB_CLASS_MAP, formatData;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                subjectId = _this4.selectedSubject.code;
                _this4$recordParams = _this4.recordParams, pageSize = _this4$recordParams.pageSize, offset = _this4$recordParams.offset;
                _context4.next = 4;
                return _getHistory({
                  subjectId: subjectId,
                  pageSize: pageSize,
                  offset: offset
                });

              case 4:
                _yield$_getHistory = _context4.sent;
                status = _yield$_getHistory.status;
                data = _yield$_getHistory.data;

                if (status === 1 && Array.isArray(data)) {
                  HISTORY_CLASSNAME_MAP = {
                    1: 'record-item__tag--video',
                    2: 'record-item__tag--note',
                    3: 'record-item__tag--card',
                    4: 'record-item__tag--submit',
                    5: 'record-item__tag--submit'
                  };
                  SUB_NAME_MAP = {
                    1: '学习分册',
                    2: '练习分册'
                  };
                  SUB_CLASS_MAP = {
                    1: 'green',
                    2: 'yellow'
                  };
                  formatData = data.map(function (item) {
                    var contentType = item.contentType,
                        subPreciousType = item.subPreciousType;
                    return _objectSpread(_objectSpread({}, item), {}, {
                      subjectId: subjectId,
                      className: HISTORY_CLASSNAME_MAP[contentType],
                      subPreciousName: SUB_NAME_MAP[subPreciousType],
                      subPreciousClass: SUB_CLASS_MAP[subPreciousType]
                    });
                  }); // 第一页特殊处理，涉及到刷新

                  _this4.recordList = offset === 0 ? formatData : [].concat(_toConsumableArray(_this4.recordList), _toConsumableArray(formatData));
                  _this4.showMoreBtn = formatData.length === pageSize;
                } // 请求完毕


                _this4.isRecordLoading = false;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getServices: function getServices() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, _yield$_getServices, status, data, SERVICE_TYPES, SERVICE_CLASSNAME_MAP, SERVICE_TITLE_IMG_MAP, exclusiveList;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = {
                  edu: _this5.edu,
                  subjectId: _this5.selectedSubject.code,
                  entry: 1
                };
                _context5.next = 3;
                return _getServices(params);

              case 3:
                _yield$_getServices = _context5.sent;
                status = _yield$_getServices.status;
                data = _yield$_getServices.data;

                if (status === 1 && data) {
                  SERVICE_TYPES = [1, 2, 3, 6];
                  SERVICE_CLASSNAME_MAP = {
                    1: 'item__content--weak',
                    2: 'item__content--similar',
                    3: 'item__content--difficulty',
                    6: 'item__content--error'
                  };
                  SERVICE_TITLE_IMG_MAP = {
                    1: _this5.$resource('home_service_title_weaks.png'),
                    2: _this5.$resource('home_service_title_similars.png'),
                    3: _this5.$resource('home_service_title_difficultys.png'),
                    6: _this5.$resource('home_service_title_errors.png')
                  };
                  exclusiveList = data.exclusiveList;
                  _this5.serviceList = exclusiveList.filter(function (item) {
                    return SERVICE_TYPES.includes(item.type);
                  }).map(function (item) {
                    return _objectSpread({
                      className: SERVICE_CLASSNAME_MAP[item.type],
                      titleUrl: SERVICE_TITLE_IMG_MAP[item.type]
                    }, item);
                  });
                } else {
                  _this5.serviceList = DEFAULT_SERVICES;
                }

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    getBoxes: function getBoxes() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var params, _yield$_getBoxes, status, data, boxList;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                params = {
                  edu: _this6.edu,
                  subjectId: _this6.selectedSubject.code
                };
                _context6.next = 3;
                return _getBoxes(params);

              case 3:
                _yield$_getBoxes = _context6.sent;
                status = _yield$_getBoxes.status;
                data = _yield$_getBoxes.data;

                if (status === 1 && data) {
                  boxList = data.boxList;
                  _this6.studyList = boxList.map(function (item) {
                    return _objectSpread(_objectSpread({}, item), params);
                  });
                } else {
                  _this6.studyList = [];
                }

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};